<template>
  <div v-if="showSchedule" id="confirm-container">
    <div class="grid-column ai-c gap-10">
      <div class="grid-column jc-s gap-5">
        <img src="@shared/assets/img/service/notification.svg" alt="notification" />
        <div class="sac__font-16 f-white semi-bold">Service Requested:</div>
      </div>
      <div class="sac__font-14 f-white">
        {{ serviceRequestedDate }}
      </div>
    </div>
    <button
      type="button"
      class="sac__button-med2 bg-default"
      @click="handleRequestAction('schedule-request', ActionStatus.Scheduled)"
    >
      <span class="sac__font-14 f-white semi-bold">Schedule</span>
      <img class="img-size-16" src="@shared/assets/img/general/calendar-white.png" alt="calendar" />
    </button>
  </div>
  <div v-else-if="showReschedule" id="confirm-container">
    <div class="grid-column ai-c gap-10">
      <div class="grid-column jc-s gap-5">
        <img src="@shared/assets/img/service/notification.svg" alt="notification" />
        <div class="sac__font-16 f-white semi-bold">Reschedule Requested:</div>
      </div>
      <div class="sac__font-14 f-white">
        {{ serviceRescheduleDate }}
      </div>
    </div>
    <div class="grid-column ai-c jc-b gap-10">
      <fragment v-if="processingAction">
        <img src="@shared/assets/img/general/loading-mini-white.svg" alt="loading" />
      </fragment>
      <fragment v-else>
        <button
          type="button"
          class="sac__button-med2 bg-default"
          @click="handleRescheduleRequest(true)"
        >
          <span class="sac__font-14 f-white semi-bold">Accept</span>
          <img
            class="img-size-16"
            src="@shared/assets/img/general/svg/check-white.svg"
            alt="check"
          />
        </button>
        <button
          type="button"
          class="sac__button-med2 bg-red"
          @click="handleRescheduleRequest(false)"
        >
          <span class="sac__font-14 f-white semi-bold">Decline</span>
          <img class="img-size-16" src="@shared/assets/img/general/svg/x-white.svg" alt="x" />
        </button>
      </fragment>
    </div>
  </div>
  <div v-else-if="showCancel" id="confirm-container">
    <div class="grid-column ai-c gap-10">
      <div class="grid-column jc-s gap-5">
        <img src="@shared/assets/img/service/notification.svg" alt="notification" />
        <div class="sac__font-16 f-white semi-bold">Cancellation Requested:</div>
      </div>
      <div class="sac__font-14 f-white">
        {{ serviceItem.customerNotes }}
      </div>
    </div>
    <div class="grid-column ai-c jc-b gap-10">
      <fragment v-if="processingAction">
        <img src="@shared/assets/img/general/loading-mini-white.svg" alt="loading" />
      </fragment>
      <fragment v-else>
        <button
          type="button"
          class="sac__button-med2 bg-default"
          @click="handleCancelRequest(true)"
        >
          <span class="sac__font-14 f-white semi-bold">Accept</span>
          <img
            class="img-size-16"
            src="@shared/assets/img/general/svg/check-white.svg"
            alt="check"
          />
        </button>
        <button type="button" class="sac__button-med2 bg-red" @click="handleCancelRequest(false)">
          <span class="sac__font-14 f-white semi-bold">Decline</span>
          <img class="img-size-16" src="@shared/assets/img/general/svg/x-white.svg" alt="x" />
        </button>
      </fragment>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import ActionStatus from '@shared/lib/constant/ActionStatus';
import serviceMixin from '../../../mixins/serviceMixin';

export default {
  name: 'ConfirmRequest',
  mixins: [serviceMixin],
  props: {
    serviceItem: Object,
  },
  computed: {
    serviceRequestedDate() {
      const { requestedDate, requestedTimes } = this.serviceItem;
      if (requestedDate && requestedTimes) {
        const day = moment(requestedDate).format('MMM DD');
        return `${day} between ${requestedTimes}`;
      }
      return '--';
    },
    serviceRescheduleDate() {
      const { requestedDate, requestedTime } = this.serviceItem;
      if (requestedDate && requestedTime) {
        const day = moment(requestedDate).format('MMM DD');
        return `${day}, ${requestedTime}`;
      }
      return '--';
    },
    showSchedule() {
      return this.serviceItem.serviceStatus === ActionStatus.Pending;
    },
    showReschedule() {
      return this.serviceItem.serviceStatus === ActionStatus.Reschedule_Request;
    },
    showCancel() {
      return this.serviceItem.serviceStatus === ActionStatus.Cancellation_Pending;
    },
  },
  methods: {
    async handleRescheduleRequest(action) {
      if (action) {
        const request = {
          ...this.serviceItem,
          actionStatus: ActionStatus.Scheduled,
          scheduleTime: this.serviceItem.requestedTime,
          scheduleDate: this.serviceItem.requestedDate,
        };
        await this.$store.dispatch('updateServiceJob', request);
      } else {
        const request = {
          ...this.serviceItem,
          actionStatus: ActionStatus.Scheduled,
          scheduleTime: this.serviceItem.scheduleTime,
          scheduleDate: this.serviceItem.scheduleDate,
        };
        await this.$store.dispatch('updateServiceJob', request);
      }
    },
    async handleCancelRequest(action) {
      if (action) {
        const request = {
          ...this.serviceItem,
          actionStatus: ActionStatus.Cancelled,
        };
        await this.$store.dispatch('updateServiceJob', request);
      } else {
        const request = {
          ...this.serviceItem,
          actionStatus: ActionStatus.Scheduled,
        };
        await this.$store.dispatch('updateServiceJob', request);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@shared/assets/styles/base.scss';
#confirm-container {
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: center;
  background-color: $N90;
  border-radius: 10px;
  padding: 20px;
}
</style>
